import {
  type App,
  Category,
  type Menu,
  MenuVariant,
  Permission,
  PosProduct,
  type Product,
  type User,
  type Venue,
  VariantVariablesByApp
} from 'generated/graphql';

export const apps: App[] = [
  {
    id: '1',
    name: 'Mr Yum',
    image: `/temp/mr-yum.png`
  },
  {
    id: '2',
    name: 'DoorDash',
    image: `/temp/doordash.png`,
    internalAppId: 'doordash'
  },
  {
    id: '3',
    name: 'MenuLog',
    image: `/temp/menulog.png`,
    internalAppId: 'flyt'
  },
  {
    id: '4',
    name: 'Uber Eats',
    image: `/temp/uber-eats.png`,
    internalAppId: 'ubereats'
  },
  {
    id: '5',
    name: 'Foodora',
    image: `/temp/foodora.png`
  }
];

export const menuItems: Product[] = [
  {
    __typename: 'Product',
    mmId: '123abc',
    posId: '123abc',
    imageUri: '/temp/burger1.png',
    name: 'Aussie Burger',
    description: 'Aussie Burger description',
    dietary: ['dietary-test', 'other-test', 'dietary-third-test'],
    variablesByApp: [
      {
        app: apps[0],
        price: 1322,
        availability: 'available'
      },
      {
        app: apps[1],
        price: 1322,
        availability: 'available'
      },
      {
        app: apps[2],
        price: 1322,
        availability: 'available'
      }
    ],
    bundledItems: [],
    includedItems: [],
    menuDir: [],
    options: [
      {
        customPosId: 'abc',
        max: 5,
        min: 0,
        mmId: 'cba',
        name: 'test options',
        posId: 'abc123',
        variants: []
      }
    ],
    surcounts: [],
    tags: ['test', 'other-test', 'third-test']
  },
  {
    __typename: 'Product',
    mmId: '123cba',
    posId: '123cba',
    imageUri: '/temp/burger2.png',
    name: `Burger By Bob`,
    description: 'Aussie Burger description',
    dietary: [],
    variablesByApp: [
      {
        app: apps[0],
        price: 1400,
        availability: 'unavailable'
      },
      {
        app: apps[1],
        price: 1600,
        availability: 'unavailable'
      },
      {
        app: apps[2],
        price: 1400,
        availability: 'unavailable'
      },
      {
        app: apps[3],
        price: 1600,
        availability: 'unavailable'
      }
    ],
    bundledItems: [],
    includedItems: [],
    menuDir: [],
    options: [],
    surcounts: [],
    tags: []
  },
  {
    __typename: 'Product',
    mmId: '123xyz',
    posId: '123xyz',
    imageUri: '/temp/burger3.png',
    name: 'Cheeseburger',
    description: 'Aussie Burger description',
    dietary: [],
    variablesByApp: [
      {
        app: apps[2],
        price: 1322,
        availability: 'unavailable'
      }
    ],
    bundledItems: [],
    includedItems: [],
    menuDir: [],
    options: [],
    surcounts: [],
    tags: []
  },
  {
    __typename: 'Product',
    mmId: '321abc',
    posId: '321abc',
    imageUri: '/temp/burger1.png',
    name: `Bob's Burger`,
    description: 'Aussie Burger description',
    dietary: [],
    variablesByApp: [
      {
        app: apps[0],
        price: 1400,
        availability: 'available'
      },
      {
        app: apps[1],
        price: 1600,
        availability: 'available'
      },
      {
        app: apps[2],
        price: 1400,
        availability: 'available'
      },
      {
        app: apps[3],
        price: 1600,
        availability: 'available'
      }
    ],
    bundledItems: [],
    includedItems: [],
    menuDir: [],
    options: [],
    surcounts: [],
    tags: []
  }
];

export const menuItemsVariant: MenuVariant[] = [
  {
    __typename: 'MenuVariant',
    mmId: '123abc',
    posId: '123abc',
    name: 'Aussie Burger',
    variablesByApp: [
      {
        app: apps[0],
        price: 1322,
        availability: 'available'
      },
      {
        app: apps[1],
        price: 1322,
        availability: 'available'
      },
      {
        app: apps[2],
        price: 1322,
        availability: 'available'
      }
    ]
  },
  {
    __typename: 'MenuVariant',
    mmId: '123cba',
    posId: '123cba',
    name: `Burger By Bob`,
    variablesByApp: [
      {
        app: apps[0],
        price: 1400,
        availability: 'unavailable'
      },
      {
        app: apps[1],
        price: 1600,
        availability: 'unavailable'
      },
      {
        app: apps[2],
        price: 1400,
        availability: 'unavailable'
      },
      {
        app: apps[3],
        price: 1600,
        availability: 'unavailable'
      }
    ]
  },
  {
    __typename: 'MenuVariant',
    mmId: '123xyz',
    posId: '123xyz',
    name: 'Cheeseburger',
    variablesByApp: [
      {
        app: apps[2],
        price: 1322,
        availability: 'unavailable'
      }
    ]
  },
  {
    __typename: 'MenuVariant',
    mmId: '321abc',
    posId: '321abc',
    name: `Bob's Burger`,
    variablesByApp: [
      {
        app: apps[0],
        price: 1400,
        availability: 'available'
      },
      {
        app: apps[1],
        price: 1600,
        availability: 'available'
      },
      {
        app: apps[2],
        price: 1400,
        availability: 'available'
      },
      {
        app: apps[3],
        price: 1600,
        availability: 'available'
      }
    ]
  }
];

export const categories: Category[] = [
  {
    category: 'Burger',
    displayOrder: 0,
    idsByApp: [],
    mmId: 'id0',
    productIds: []
  },
  {
    category: 'Laksa',
    displayOrder: 1,
    idsByApp: [],
    mmId: 'id1',
    productIds: []
  },
  {
    category: 'Sushi',
    displayOrder: 2,
    idsByApp: [],
    mmId: 'id2',
    productIds: []
  }
];

export const variants: MenuVariant[] = [
  {
    posId: 'ETA4IPSKIFKYYTF2VGTUSPD5',
    name: 'Small',
    customPosId: '',
    variablesByApp: [
      {
        app: {
          id: '1',
          name: 'Mr Yum',
          image: 'mryum.png'
        },
        availability: 'available',
        price: 0
      },
      {
        app: {
          id: '2',
          name: 'Me&U',
          image: 'meandu.png'
        },
        availability: 'available',
        price: 0
      }
    ],
    mmId: 'f34dd4ce61f1127d15c9959071abdc62'
  },
  {
    posId: 'BIGBEKYIF7NJJSO4V27NEFTV',
    name: 'Large Size',
    customPosId: '',
    variablesByApp: [
      {
        app: {
          id: '1',
          name: 'Mr Yum',
          image: 'mryum.png'
        },
        availability: 'available',
        price: 70
      },
      {
        app: {
          id: '2',
          name: 'Me&U',
          image: 'meandu.png'
        },
        availability: 'available',
        price: 70
      }
    ],
    mmId: '2e4c6ecadccf46399a1229c61aa1f4e6'
  },
  {
    posId: '2AS6GFZDPGHF3MWDHWHCJBAB',
    name: 'Small T/A',
    customPosId: '',
    variablesByApp: [
      {
        app: {
          id: '1',
          name: 'Mr Yum',
          image: 'mryum.png'
        },
        availability: 'available',
        price: 200
      },
      {
        app: {
          id: '2',
          name: 'Me&U',
          image: 'meandu.png'
        },
        availability: 'available',
        price: 200
      }
    ],
    mmId: 'db8ad25b0f473dbb8a08b079d0ab7b3e'
  }
];

export const menus: Menu[] = [
  {
    __typename: 'Menu',
    mmId: 'abc123',
    name: `Bob's Avocado Menu`,
    neverPublished: false,
    imageUri: '/temp/menu.jpg',
    createdAt: '2021-01-01T00:00:00.000Z',
    updatedAt: '2021-01-01T00:00:00.000Z',
    uri: 'https://connect.mymenu.io/abc123',
    description: 'This is a description',
    version: 'TEST',
    options: [],
    surcounts: [],
    products: menuItems,
    variants,
    categories: [
      {
        mmId: '1',
        displayOrder: 0,
        imageUri: '',
        category: 'Yeah Boy',
        description: `When you're too hungry to decide, we got you boo`,
        productIds: menuItems.slice(0, 1).map((item) => item.posId) as string[],
        idsByApp: apps.slice(0, -1).map((app) => ({
          app: {
            id: app.id,
            name: app.name
          },
          id: 'abcd'
        }))
      },
      {
        mmId: '2',
        displayOrder: 1,
        imageUri: '',
        category: 'Bites and Sharing',
        description: `Perfect to share, or not...`,
        productIds: menuItems.map((item) => item.posId) as string[],
        idsByApp: apps.slice(0, -1).map((app) => ({
          app: {
            id: app.id,
            name: app.name
          },
          id: 'abcd'
        }))
      },
      {
        mmId: '3',
        displayOrder: 2,
        imageUri: '',
        category: 'Bowls',
        description: `Nourish bowls that love your soul`,
        productIds: menuItems.slice(0, 3).map((item) => item.posId) as string[],
        idsByApp: apps.slice(0, -1).map((app) => ({
          app: {
            id: app.id,
            name: app.name
          },
          id: 'abcd'
        }))
      }
    ],
    apps: [
      {
        id: '1',
        name: 'Uber Eats',
        image: `/temp/uber-eats.png`
      }
    ]
  },
  {
    mmId: 'abc321',
    name: `Bob's Delightful Dessert Menu`,
    neverPublished: false,
    imageUri: '/temp/menu.jpg',
    createdAt: '2021-01-01T00:00:00.000Z',
    updatedAt: '2021-01-01T00:00:00.000Z',
    uri: 'https://connect.mymenu.io/abc123',
    description: 'This is a description',
    version: '1.0.0',
    options: [],
    surcounts: [],
    products: menuItems,
    variants: [],
    categories: [
      {
        mmId: '1',
        displayOrder: 0,
        imageUri: '',
        category: 'Yeah Boy',
        description: `When you're too hungry to decide, we got you boo`,
        productIds: menuItems.slice(0, 1).map((item) => item.posId) as string[],
        idsByApp: [
          {
            app: {
              id: '4',
              name: 'Mr Yum'
            },
            id: `abcd`
          }
        ]
      },
      {
        mmId: '2',
        displayOrder: 1,
        imageUri: '',
        category: 'Bites and Sharing',
        description: `Perfect to share, or not...`,
        productIds: menuItems.map((item) => item.posId) as string[],
        idsByApp: [
          {
            app: {
              id: '4',
              name: 'Mr Yum'
            },
            id: `abcd`
          }
        ]
      },
      {
        mmId: '3',
        displayOrder: 2,
        imageUri: '',
        category: 'Bowls',
        description: `Nourish bowls that love your soul`,
        productIds: menuItems.slice(0, 3).map((item) => item.posId) as string[],
        idsByApp: [
          {
            app: {
              id: '4',
              name: 'Mr Yum'
            },
            id: `abcd`
          }
        ]
      }
    ],
    apps: [
      {
        id: '4',
        name: 'Mr Yum',
        image: `/temp/mr-yum.png`
      }
    ]
  },
  {
    mmId: 'abc345',
    name: `Bob's Plump Pies Dinner Menu`,
    neverPublished: false,
    imageUri: '/temp/menu.jpg',
    createdAt: '2021-01-01T00:00:00.000Z',
    updatedAt: '2021-01-01T00:00:00.000Z',
    uri: 'https://connect.mymenu.io/abc123',
    description: 'This is a description',
    version: '1.0.0',
    options: [],
    surcounts: [],
    products: menuItems.filter((_, index) => index),
    variants: [],
    categories: [
      {
        mmId: '1',
        displayOrder: 0,
        imageUri: '',
        category: 'Yeah Boy',
        description: `When you're too hungry to decide, we got you boo`,
        productIds: menuItems.slice(0, 1).map((item) => item.posId) as string[],
        idsByApp: apps.slice(0, -2).map((app) => ({
          app: {
            id: app.id,
            name: app.name
          },
          id: 'abcd'
        }))
      },
      {
        mmId: '2',
        displayOrder: 1,
        imageUri: '',
        category: 'Bites and Sharing',
        description: `Perfect to share, or not...`,
        productIds: menuItems.map((item) => item.posId) as string[],
        idsByApp: apps.slice(0, -2).map((app) => ({
          app: {
            id: app.id,
            name: app.name
          },
          id: 'abcd'
        }))
      },
      {
        mmId: '3',
        displayOrder: 2,
        imageUri: '',
        category: 'Bowls',
        description: `Nourish bowls that love your soul`,
        productIds: menuItems.slice(0, 3).map((item) => item.posId) as string[],
        idsByApp: apps.slice(0, -2).map((app) => ({
          app: {
            id: app.id,
            name: app.name
          },
          id: 'abcd'
        }))
      }
    ],
    apps: [
      {
        id: '2',
        name: 'Deliveroo',
        image: `/temp/deliveroo.png`
      }
    ]
  }
];

export const mockVenue: Omit<Venue, 'menus'> & { menus: Menu[] } = {
  __typename: 'Venue',
  addressLine1: '123 Fake St',
  addressLine2: '',
  city: 'Faketown',
  country: 'Australia',
  hashedId: 'abc123',
  menus,
  name: 'Test Venue',
  postalCode: '3056',
  state: 'Victoria',
  status: 'active'
};

export const mockVenue2: Venue = {
  __typename: 'Venue',
  addressLine1: '123 Fake St',
  addressLine2: '',
  city: 'Faketown',
  country: 'Australia',
  hashedId: 'abc321',
  menus,
  name: 'Test Venue Two',
  postalCode: '3056',
  state: 'Victoria',
  status: 'active'
};

export const mockUser: User = {
  __typename: 'User',
  familyName: 'Smith',
  givenName: 'John',
  id: 'abc123',
  organisationIds: ['def456'],
  venues: [mockVenue, mockVenue2],
  permissions: [Permission.ViewMenu, Permission.PublishMenu]
};

export const mockVariablesByApp: VariantVariablesByApp[] = [
  {
    app: apps[0],
    price: 1400,
    availability: 'available'
  },
  {
    app: apps[1],
    price: 1400,
    availability: 'available'
  }
];
export const mockVariablesByAppUnderFourWithVaryingPrice: VariantVariablesByApp[] = [
  {
    app: apps[0],
    price: 1400,
    availability: 'available'
  },
  {
    app: apps[1],
    price: 100,
    availability: 'available'
  }
];

export const mockVariablesByAppOverFourWithVaryingPrice: VariantVariablesByApp[] = [
  {
    app: apps[0],
    price: 1400,
    availability: 'available'
  },
  {
    app: apps[1],
    price: 100,
    availability: 'available'
  },
  {
    app: apps[2],
    price: 1400,
    availability: 'available'
  },
  {
    app: apps[3],
    price: 1400,
    availability: 'available'
  },
  {
    app: apps[4],
    price: 1400,
    availability: 'available'
  }
];

export const dietaryEnums = [
  'Gluten Free',
  'Vegan',
  'Vegetarian',
  'Dairy Free',
  'Nut Free',
  'Soy Free',
  'Egg Free',
  'Halal',
  'Kosher'
];

export const posProduct: PosProduct = {
  __typename: 'POSProduct',
  posId: '123abc',
  imageUri: '/temp/burger1.png',
  name: 'Aussie Burger',
  description: 'Aussie Burger description',
  dietary: ['dietary-test', 'other-test', 'dietary-third-test'],
  unitPrice: 1322,
  availability: 'available',
  options: [
    {
      customPosId: 'abc',
      max: 5,
      min: 0,
      name: 'test options',
      posId: 'abc123',
      variants: []
    }
  ],
  tags: ['test', 'other-test', 'third-test']
};
